module.exports = __webpack_public_path__ + "img/3.d47e1aef.svg";